export const ACCEPT_EMAILS_AND_SPECIAL_OFFERS_MESSAGE_ID = 'acceptEmailsAndSpecialOffers';
export const ACCEPT_TERMS_AND_PRIVACY_INTRO_MESSAGE_ID = 'acceptTermsAndPrivacyIntro';
export const AGREE_TO_TERMS_OF_SERVICE_ERROR = 'agreeToTermsOfServiceError';
export const REWARDS_POLICY_TERMS_MESSAGE_ID = 'rewardsPolicy';
